/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateSessionHandoffRequestBody = {
  /**
   * The rendered handoff document (markdown). Size-capped; the daemon renders deterministically from the local transcript.
   */
  content: string;
  /**
   * Native harness session identifier the handoff was rendered from. Speakeasy derives its chat id from this the same way hook ingest does; a not-yet-captured session can still mint a link.
   */
  sessionId: string;
  /**
   * Harness the session originated in, as detected by the agent (e.g. claude-code, codex).
   */
  sourceSurface?: string | undefined;
  /**
   * Requested link lifetime in seconds. Clamped to [60, 3600]; defaults to 900 when omitted.
   */
  ttlSeconds?: number | undefined;
};

/** @internal */
export type CreateSessionHandoffRequestBody$Outbound = {
  content: string;
  session_id: string;
  source_surface?: string | undefined;
  ttl_seconds?: number | undefined;
};

/** @internal */
export const CreateSessionHandoffRequestBody$outboundSchema: z.ZodMiniType<
  CreateSessionHandoffRequestBody$Outbound,
  CreateSessionHandoffRequestBody
> = z.pipe(
  z.object({
    content: z.string(),
    sessionId: z.string(),
    sourceSurface: z.optional(z.string()),
    ttlSeconds: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionId: "session_id",
      sourceSurface: "source_surface",
      ttlSeconds: "ttl_seconds",
    });
  }),
);

export function createSessionHandoffRequestBodyToJSON(
  createSessionHandoffRequestBody: CreateSessionHandoffRequestBody,
): string {
  return JSON.stringify(
    CreateSessionHandoffRequestBody$outboundSchema.parse(
      createSessionHandoffRequestBody,
    ),
  );
}
